'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { Tabs } from '@benzinga/core-ui';

export const MARKET_PAGES_TABS = [
  { key: '/markets', name: 'Markets', link: '/markets' },
  { key: '/premarket', name: 'Premarket', link: '/premarket' },
  { key: '/premarket-playbook', name: 'Premarket Playbook', link: '/premarket-playbook' },
  { key: '/movers', name: 'Movers', link: '/movers' },
  { key: '/market-update', name: 'Market Update', link: '/market-update' },
  { key: '/analyst-stock-ratings', name: 'Analyst Ratings', link: '/analyst-stock-ratings' },
  { key: '/earnings', name: 'Earnings Calendar', link: '/earnings' },
];

function resolveActiveTab(pathname: string | null): string {
  if (!pathname) return '/markets';
  if (pathname.startsWith('/premarket-playbook')) return '/premarket-playbook';
  if (pathname.startsWith('/premarket')) return '/premarket';
  if (pathname.startsWith('/movers')) return '/movers';
  if (pathname.startsWith('/market-update')) return '/market-update';
  if (pathname.startsWith('/analyst-stock-ratings') || pathname.startsWith('/analyst-ratings')) {
    return '/analyst-stock-ratings';
  }
  if (pathname.startsWith('/earnings') || pathname.startsWith('/calendars/earnings')) {
    return '/earnings';
  }
  if (pathname.startsWith('/markets')) return '/markets';
  return pathname;
}

export function MarketPagesNav() {
  const pathname = usePathname();

  return (
    <div className="homepage-layout-main">
      <div className="w-full flex items-center justify-center px-2 tab-header">
        <div className="layout-container max-w-[1400px] w-full">
          <Tabs
            activeTab={resolveActiveTab(pathname)}
            isShowMoreButtonEnabled={false}
            tabBarGutter={4}
            tabs={MARKET_PAGES_TABS}
            variant="lifted"
          />
        </div>
      </div>
    </div>
  );
}
